import { UI } from '@genial/components';
import { BoxRadius, Typography } from '@genial/design-tokens';
import React from 'react';

import { SubscriptionHistoryListItemProps } from '..';
import { HintButton } from '../../../../../../../components/HintButton';
import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { TableContentItemStatus } from '../../../../../../../components/TableContent/status';
import { getValidatedStatusIcon } from '../../../../../../../utils/getValidatedStatusIcon';
import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { subscriptionSubscriptionHistoryTableHead } from '../../SubscriptionHistoryHeader/constants';

export const SubscriptionHistoryListItemDesktop: React.FC<SubscriptionHistoryListItemProps> = ({
  historyItem,
  isDisabled,
  disabledMessage,
  onCancel,
}) => {
  const getFlex = (index: number) => {
    const currentHead = subscriptionSubscriptionHistoryTableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" h="80px">
      <LateralBar
        backgroundColor="product.rendavariavel"
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{historyItem.customerNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{historyItem.advisorNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{`${historyItem.requestedQuantity}`}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{historyItem.totalValueFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemStatus
          basketAdvisorStatus={{
            isActive: true,
            statusId: 1,
            statusIcon: getValidatedStatusIcon(historyItem.status),
            statusAlias: historyItem.statusAlias,
          }}
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <HintButton
          tooltip={disabledMessage}
          variant="textLink"
          isDisabled={isDisabled}
          _text={{
            color: 'feedback.error.default',
            fontFamily: Typography['fontfamily.base.semibold'],
          }}
          onPress={onCancel}
          rightIcon={<UI.Icon name="Trash" size="xxxs" color="feedback.error.default" />}>
          CANCELAR
        </HintButton>
      </TableContentItemColumn>
    </TableContent>
  );
};
